import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Title from 'shared/components/Title'
import { Loader } from 'shared/components/Loader'
import constants from 'config/constants'
import { IntegrationContainer } from 'components/IntegrationContainer'

const IntegrationSubPageHeader = ({ title, helpArticleLink, helpArticleText }) => (
  <div className="admin-heading">
    <div className="ui stackable grid">
      <div className="eight wide column">
        <h2>{title}</h2>
      </div>
      <div className="eight wide column right aligned bottom aligned">
        <p>
          <a href={helpArticleLink} target="_blank" rel="noopener">
            <i className="icon far fa-book" />
            {helpArticleText}
          </a>
        </p>
      </div>
    </div>
  </div>
)

IntegrationSubPageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  helpArticleLink: PropTypes.string.isRequired,
  helpArticleText: PropTypes.string.isRequired,
}

const Hide = styled.div`
  visibility: hidden;
  opacity: 0;
`

const AuthenticatedPanel = () => (
  <div className="ui segment">
    <div className="ui stackable grid">
      <div className="ten wide column middle aligned">
        <h4>
          <i className="ui icon fas fa-check green" /> Authenticated with Dropbox
        </h4>
      </div>

      <Hide className="six wide column right aligned">
        <button className="ui negative basic button">Revoke Access</button>
      </Hide>
    </div>
  </div>
)

const UnauthenticatedPanel = ({ userAccountId }) => (
  <div className="ui secondary segment">
    <div className="ui stackable grid">
      <div className="ten wide column middle aligned">
        <h4>
          <i className="ui icon info circle" /> Connect your Dropbox account to Simplesat
        </h4>
      </div>

      <div className="six wide column right aligned">
        <a
          href={`https://www.dropbox.com/oauth2/authorize?client_id=${constants.dropboxClientId}&token_access_type=offline&response_type=code&redirect_uri=${constants.backendHost}/api/dropbox/oauth2/token/&state=${userAccountId}`}
        >
          <button className="ui primary button">Authenticate</button>
        </a>
      </div>
    </div>
  </div>
)

UnauthenticatedPanel.propTypes = {
  userId: PropTypes.number.isRequired,
}

export const DropboxIntegrationSubPage = ({ isAuthenticated, loading, userAccountId }) => (
  <IntegrationContainer>
    <Title title="Dropbox" />
    {loading ? <Loader /> : null}
    <IntegrationSubPageHeader
      title="Export feedback to Dropbox"
      helpArticleLink="https://help.simplesat.io/integrations/dropbox/export-csv-feedback-to-dropbox"
      helpArticleText="Learn more about integrating with Dropbox"
    />
    <div className="ui stackable grid">
      <div className="twelve wide column">
        <p>
          This integration will export Simplesat feedback as a CSV file into a Dropbox folder. Once
          activated, you can use the integration to display feedback data in popular dashboard and
          BI tools.
        </p>

        <div>
          <strong>This integration will:</strong>
          <ul>
            <li>
              Create a new folder named <code>Simplesat</code> in your Dropbox account (a new{' '}
              <code>Apps</code> folder will also be created if it doesn't exist yet)
            </li>
            <li>
              Add a new file named <code>simplesat_feedback.csv</code> to the folder above
            </li>
            <li>Replace the file every 30 minutes if new feedback has been provided</li>
          </ul>
        </div>

        <p>
          <em>Note: You can revoke this app's permission in your Dropbox account.</em>
        </p>

        <hr />

        <div>
          {loading ? null : isAuthenticated ? (
            // TODO: Be able to remove Dropbox integration (requires BE)
            <AuthenticatedPanel />
          ) : (
            <UnauthenticatedPanel userAccountId={userAccountId} />
          )}
        </div>
      </div>
    </div>
  </IntegrationContainer>
)

DropboxIntegrationSubPage.propTypes = {
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Integrations/Dropbox/index.js